// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".01768e22467032661106ec4e2aa98d449f44c34b.chunk.bundle.js";
};